import React from 'react';
import DOMPurify from 'dompurify';

export default class ModalPortalDestination extends React.Component {
  state = {}

  onDiv = (container) => {
    if (!this.state.container) {
      this.setState({ container });
      this.props.onRef(container);
    }
  }

  componentWillUnmount() {
    const { container } = this.state;
    if (container && container.parentNode) {
      // IE lacks element.remove() ...
      container.parentNode.removeChild(container);
    }
  }

  render() {
    const {
      className,
      ariaProps,
    } = this.props;

    if (this.props.frozenContent) {
      return  (
        <div
          className={className}
          role='dialog'
          aria-modal={true}
          {...ariaProps}
          dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(this.props.frozenContent) }}
        />
      )
    }

    return (
      <div
        className={className}
        role='dialog'
        aria-modal={true}
        {...ariaProps}
        ref={this.onDiv}
      />
    );
  }
}
